import { isPlatformBrowser } from '@angular/common';
import { Component, inject, OnInit, PLATFORM_ID, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoaderComponent, ResponsiveHelperComponent, ThemeService, ToasterComponent } from '@vallift/ngl';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToasterComponent, ResponsiveHelperComponent, LoaderComponent],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements OnInit {
  private readonly themeService = inject(ThemeService);
  private readonly platformId = inject(PLATFORM_ID);

  protected readonly title = signal('form-ops-ui');

  ngOnInit(): void {
    this.themeService.init();

    if (isPlatformBrowser(this.platformId) && !localStorage.getItem('app-theme')) {
      this.themeService.setThemeMode('light');
    }
  }
}
